import Vue from "vue";
import VueAnalytics from "vue-analytics";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faBars as fasBars,
  faShareAlt as fasShareAlt,
  faChevronLeft as fasChevronLeft,
  faChevronRight as fasChevronRight,
  faChevronDown as fasChevronDown,
  faUser as fasUser,
  faTimes as fasTimes,
  faCheckCircle as fasCheckCircle,
  faCheck as fasCheck,
  faClock as fasClock,
  faSignOut as fasSignOut,
  faSyncAlt as FasSyncAlt,
} from "@fortawesome/pro-solid-svg-icons";
import {
  faCircle as farCircle,
  faEye as farEye,
  faEyeSlash as farEyeSlash,
  faTrashAlt as farTrashAlt,
  faShoppingCart as farShoppingCart,
  faSearch as farSearch,
  faCircleNotch as farCircleNotch,
  faPlusCircle as farPlusCircle,
  faMinusCircle as farMinusCircle,
  faClone as FarClone,
} from "@fortawesome/pro-regular-svg-icons";
import {
  faTrashAlt as falTrashAlt,
  faTimes as falTimes,
  faFileExcel as falFileExcel,
  faFilePowerpoint as falFilePowerpoint,
  faQuestionCircle as falQuestionCircle,
  faLightbulb as falLightbulb
} from "@fortawesome/pro-light-svg-icons";
import {
  faGooglePlusG,
  faFacebookSquare,
  faTwitter,
  faLinkedinIn,
} from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon, FontAwesomeLayers } from "@fortawesome/vue-fontawesome";

import VueViewports from "vue-viewports";

import App from "./App.vue";
import router from "./router";
import store from "./store";
import i18n from "./i18n";
import VueMeta from "vue-meta";
import StudyNavigation from "./components/views/StudyNavigation";
import Loading from "./components/views/Loading";
import Modal from "./components/views/Modal";

import { registerFilters } from "./filters/filters";
import { INIT_STORE, PRE_INIT_STORE, SET_I18N } from "./services/constants";

library.add(
  fasBars,
  farEye,
  farEyeSlash,
  fasSignOut,
  fasShareAlt,
  farCircle,
  farTrashAlt,
  farShoppingCart,
  farSearch,
  farCircleNotch,
  farPlusCircle,
  farMinusCircle,
  FarClone,
  fasChevronLeft,
  fasChevronRight,
  fasChevronDown,
  fasUser,
  fasTimes,
  fasCheck,
  fasCheckCircle,
  fasClock,
  falQuestionCircle,
  falTrashAlt,
  falTimes,
  falFileExcel,
  falFilePowerpoint,
  faGooglePlusG,
  faFacebookSquare,
  faTwitter,
  faLinkedinIn,
  falLightbulb
);

Vue.use(VueAnalytics, {
  id: "UA-144300916-1",
  router,
});

Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true,
});

Vue.use(VueViewports);
Vue.component("Fai", FontAwesomeIcon);
Vue.component("FaiLayers", FontAwesomeLayers);
Vue.component("BigStudyNavigation", StudyNavigation);
Vue.component("Loading", Loading);
Vue.component("Modal", Modal);

registerFilters(Vue);
Vue.config.productionTip = false;

store.dispatch(PRE_INIT_STORE);
store.commit(SET_I18N, i18n);
new Vue({
  router,
  store,
  i18n,
  created() {
    store.dispatch(INIT_STORE);
  },
  render: (h) => h(App),
}).$mount("#app");
